import { opcionesSideBar, useSideBarContext, OPCION_TITULO_ACTUALIZACION_DATOS } from 'Context/SideBarContext';
import React, { useState } from 'react'
// import { Icono_Flecha_Ir } from './Sidebar_Principal';
import {ReactComponent as Flecha_Ir_Row} from "assets/icons/Sidebar_Nuevo_Opciones/flecha.svg"

interface Sidebar_Row_Props {
    subopciones: opcionesSideBar | undefined
    titulo_opcion_padre: string,
    isChild: boolean,
    icon_opcion_padre?:any,
    isSubNieto?:boolean
    
}


const Sidebar_Principal_Row = (props: Sidebar_Row_Props) => {
    const { setvaloressubMenuNieto,setsubMenuNieto ,
        setsubMenu, setvaloressubMenu, 
        settitulo_opcion_padre , setsubMenuDatosPersonales, 
        seticono_opcion_padre,settitulo_opcion_submenuNieto ,
        NOMBRE_OPCION_DATOS_PERSONALES,
        setsubMenuCuartoNivel,
        setvaloressubMenuCuartoNivel,
        settitulo_opcion_CuartoNivel
    
    
    
    } = useSideBarContext();



    const CLASE_ROW_PRINCIPAL = "sidenavPrincipalRow"
    const CLASE_ROW_HIJO = "submenuOpcionesHeader"
    
    const function_open_row = (): void => {
        setsubMenu(true);
        setvaloressubMenu(props.subopciones?.entries);
        settitulo_opcion_padre(props.titulo_opcion_padre);
        if(props.icon_opcion_padre) seticono_opcion_padre(props.icon_opcion_padre());
    }

    const function_open_datos_personales_row = ():void =>{
        setsubMenuDatosPersonales(true);
    }

    const function_open_subMenuNietos = ():void => {
        setsubMenuNieto(true);
        setvaloressubMenuNieto(props.subopciones?.entries);
        settitulo_opcion_submenuNieto(props.titulo_opcion_padre);
        if(props.icon_opcion_padre) seticono_opcion_padre(props.icon_opcion_padre());

    }
    const function_open_menuCuartoNivel = ():void => {
        setsubMenuCuartoNivel(true);
        setvaloressubMenuCuartoNivel(props.subopciones?.entries);
        settitulo_opcion_CuartoNivel(props.titulo_opcion_padre);

    }


    const functionHandleClickRow = () =>{
        if (props.subopciones?.titulo === OPCION_TITULO_ACTUALIZACION_DATOS){
            function_open_datos_personales_row()
        }
        else if(props.subopciones?.entries && !props.isChild && !props.isSubNieto){
            function_open_row()
        }
        else if(props.subopciones?.entries && props.isSubNieto){
            function_open_menuCuartoNivel()
        }
        else if(props.subopciones?.entries && props.isChild){
            function_open_subMenuNietos()
        }
        
    }

    function VerifyClassRowOption (isChild:boolean,isSubnieto:boolean|undefined,entries:opcionesSideBar | undefined){
        if(isSubnieto){
            return "rowNieto";
        }
        else if(isChild ){
            return CLASE_ROW_HIJO;
        }
        else {
            return CLASE_ROW_PRINCIPAL;
        } 
    }

    
    return (
        <div className={VerifyClassRowOption(props.isChild,props.isSubNieto,props.subopciones)} onClick={() => functionHandleClickRow()}>
           
                <div className="container_icono_Principal_Content">
                    {props.icon_opcion_padre?props.icon_opcion_padre():""}
                </div>
                <div className="text_opciones_row">
                    {props.subopciones?.titulo}
                </div>
               
                    <div className="container_arrow">
                        <Flecha_Ir_Row className="iconoFlechaIrRow"/>
                    </div>
                
                 
                    {/* <div className="container_arrow">
                        <Flecha_Ir_Row_Blanca className="iconoFlechaIrRow"/>
                    </div> */}
                
               
                {/* { props.isChild && 
                    <div className="container_arrow">
                        {Icono_Flecha_Ir}
                    </div>
                } */}
                 

        </div>
    )
}
export default Sidebar_Principal_Row;
